module.exports = __webpack_public_path__ + "static/media/sc.606d4b06.svg";